export default "__VITE_ASSET__581a4abb__"